var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baselayout"},[_c('keep-alive',{attrs:{"include":/Keep$/}},[_c('router-view')],1),_c(_vm.SiteHead,{tag:"component"}),_c(_vm.SiteFoot,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }